import React from 'react';
import { useRouter } from 'next/router';
import { Money } from '@commercetools/frontend-domain-types/product/Money';
import { CurrencyHelpers } from '@loomstateorg/shared-frontend/helpers/currencyHelpers';
import { Typography } from '@loomstateorg/shared-frontend';

interface Props {
  discountedPrice?: Money;
  price?: Money;
  regularFontSize?: 14 | 16;
  regularClassName?: string;
  asHeading?: boolean;
  medium?: boolean;
  index?: number;
}

const Prices: React.FC<Props> = ({
  price,
  discountedPrice,
  regularFontSize = 16,
  regularClassName,
  asHeading = true,
  medium,
  index = 0,
}) => {
  const { locale } = useRouter();

  return (
    <>
      {discountedPrice ? (
        <div className="flex items-center gap-8">
          <Typography
            as={asHeading ? 'h4' : undefined}
            medium={medium ?? false}
            lineHeight="loose"
            fontFamily="primaryThin"
            fontSize={14}
            className="text-accent-red md:text-14"
            data-testid={`discounted-price-${index}`}
          >
            {CurrencyHelpers.formatForCurrency(discountedPrice, locale)}
          </Typography>
          <Typography
            as={asHeading ? 'h5' : undefined}
            medium={medium ?? false}
            lineHeight="loose"
            fontFamily="primaryThin"
            fontSize={14}
            className="text-gray-500 line-through md:text-12"
            data-testid={`product-price-${index}`}
          >
            {CurrencyHelpers.formatForCurrency(price ?? '', locale)}
          </Typography>
        </div>
      ) : (
        <Typography
          as={asHeading ? 'h4' : undefined}
          medium={medium ?? asHeading}
          fontSize={regularFontSize}
          fontFamily="primaryThin"
          className={regularClassName}
          data-testid={`product-price-${index}`}
        >
          {CurrencyHelpers.formatForCurrency(price ?? 0, locale)}
        </Typography>
      )}
    </>
  );
};

export default Prices;
